export default __webpack_public_path__ + "static/media/PrintsImage02.4ed90ba0.jpg";